"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSearchSection = void 0;
exports.defaultSearchSection = {
    searchText: '',
    searchKeywords: [],
    translate: {
        searchText: 'Search Guides',
    },
};
